import e from "react";
import { TosElement as s } from "./index4.mjs";
import { ErrorBannerContainer as i } from "./index21.mjs";
const f = ({
  tncAccepted: r,
  setTncAccepted: t,
  showSalesTerms: n,
  showTermsAndConditions: o,
  hasAttemptedPayment: m,
  setHasAttemptedPayment: l
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
  s,
  {
    tncAccepted: r,
    setTncAccepted: t,
    showSalesTerms: n,
    showTermsAndConditions: o
  }
), !r && m ? /* @__PURE__ */ e.createElement(
  i,
  {
    description: I18n.t(
      "booking_engine.errors.sales_terms_not_accepted.sub_title"
    ),
    onDismiss: () => l(!1)
  }
) : null);
export {
  f as TosElementWithBanner
};
